module.exports = __webpack_public_path__ + "static/media/back-to-school-sticker.08a13d5b.svg";